/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import { _x } from '@web-stories-wp/i18n';
import PropTypes from 'prop-types';

const title = _x('Off-white Section Separator', 'sticker name', 'web-stories');

function OffWhiteSectionSeparator({ style }) {
  return (
    <svg
      style={style}
      viewBox="0 0 62 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        d="M61.0541 4.68684C60.831 6.20747 60.6096 7.7164 60.3865 9.23703C60.2269 10.3249 60.1446 11.436 59.8534 12.5045C59.5621 13.573 59.0997 14.6165 58.7443 15.6637C57.8944 18.1559 57.194 20.7298 55.7723 22.9948C55.2085 23.9039 54.6046 24.9027 53.8668 25.7147C53.2566 26.39 52.5709 27.0303 51.9475 27.7037C51.2944 28.3966 50.7472 29.0094 49.7408 29.2682C49.0974 29.4368 48.589 29.6012 47.9782 29.8224C47.0537 30.1649 45.8526 29.9172 44.8794 29.8582C42.7091 29.7075 40.6007 29.4105 38.4378 29.1174C37.4881 28.9902 36.5789 28.6777 35.6309 28.5388C34.7882 28.4153 34.0944 28.469 33.2523 28.5248C31.4873 28.6366 29.6393 28.3061 27.9431 28.7744C27.6346 28.8607 27.3684 29.0248 27.0387 29.0721C26.6677 29.1252 26.2859 29.0693 25.9052 29.0971C25.1157 29.1607 24.4213 29.3099 23.6141 29.3111C21.583 29.3121 19.5347 29.1554 17.5018 29.1681C16.4919 29.1755 16.019 28.915 15.3228 28.2514C14.2367 27.22 13.1867 26.2178 12.0376 25.2489C11.3901 24.7119 10.7809 24.0969 10.1815 23.5072C9.71139 23.044 9.07247 22.7234 8.76956 22.1293C8.26796 21.1478 7.95126 20.0977 7.41989 19.1356C6.98471 18.343 6.36866 17.7748 5.71024 17.1286C5.21728 16.6382 4.65964 16.2219 4.34528 15.6143C3.54535 14.0991 2.98013 12.451 2.75095 10.8043C2.63235 9.9625 2.251 9.2614 1.97726 8.46852C1.78771 7.92696 1.45219 7.55518 1.21627 7.05462C0.98207 6.54235 0.976856 6.0278 0.948742 5.48599C0.909737 4.83505 1.27895 4.51875 1.8428 4.15927C2.85143 3.51847 4.04156 3.10738 5.22311 2.75478C7.95258 1.93599 11.0073 1.55915 13.8656 1.23718C16.0135 0.990341 18.1769 1.18787 20.3277 1.01314C24.7266 0.642096 29.0767 -0.130389 33.5203 0.0189082C35.4341 0.084271 37.3679 0.379597 39.2623 0.669135C40.9855 0.93359 42.5426 0.863048 44.2698 0.73378C45.9706 0.600653 47.6233 0.795046 49.3207 0.960135C50.8962 1.13125 52.4877 1.10159 54.0792 1.34675C54.8692 1.46252 55.6627 1.55489 56.4493 1.69405C57.1191 1.80415 57.7334 2.10924 58.3563 2.35585C58.5092 2.41409 58.6305 2.50357 58.7851 2.55012C59.132 2.6607 59.5642 2.55675 59.8894 2.72389C60.2146 2.89103 60.2261 3.17948 60.3761 3.44043C60.5914 3.80654 60.9309 4.05942 60.8772 4.51753"
        fill="#F3E9D4"
      />
    </svg>
  );
}

OffWhiteSectionSeparator.propTypes = {
  style: PropTypes.object,
};

export default {
  aspectRatio: 62 / 30,
  svg: OffWhiteSectionSeparator,
  title,
};
